window.addEventListener("load", function() {
  try {
    let mainTabsElem = document.querySelectorAll(".main-tabs-sec .tab-collage__heading");
    if (mainTabsElem.length != 0){
      let activeTab = mainTabsElem[0];
      let hideAccordTab = document.querySelector(".tab-collage__right .tab-right-wrap");
      let activeAccord = document.querySelector(".tab-collage__card");
      if (!activeTab.classList.contains("is-active")){
         activeTab.className += " is-active main-tab-active";
        activeAccord.classList.add("is-active");
        hideAccordTab.classList.add("hide-accord-tab");
      }
      else{
        hideAccordTab.classList.add("hide-accord-tab");
      }
      mainTabsElem.forEach(function (ele) {
        ele.addEventListener("click", function () {
          if (!ele.classList.contains("main-tab-active")) {
            ele.classList.add("main-tab-active");
          }   
          if (activeTab != ele){
            activeTab.classList.remove("main-tab-active");
          }
          if ((ele.classList.contains("main-tab-active")) && (ele.classList.contains("prod-faq"))) {
            if(hideAccordTab.classList.contains("hide-accord-tab")){
              hideAccordTab.classList.remove("hide-accord-tab");
            }
          }
          else{
             if(!hideAccordTab.classList.contains("hide-accord-tab")){
              hideAccordTab.classList.add("hide-accord-tab");
            }
          }
          activeTab = ele;
        });
      });
    }
  } catch (error) {
    // handle the error here
    console.log("Tabs Not Found");
  }
});

// Mobile Tab section
window.addEventListener("load", function() {
    try {
        if (window.innerWidth < 749) {
            let tabSections = document.querySelectorAll(".product-tabs .main-tabs-sec [data-block-id]");
            let tabContents = document.querySelectorAll(".product-tabs use-animate [data-block-id]");

            tabSections.forEach((ele, i) => {
                const tabContent = tabContents[i];
                const mobileTabContent = ele.closest("li").nextElementSibling;

                if (ele.getAttribute("data-block-id") === tabContent.getAttribute("data-block-id")) {
                    const contentToAppend = tabContent.classList.contains("tab-right-wrap") ?
                        tabContent.querySelector(".tab-collage__content") :
                        tabContent.querySelector(".tab-collage__desc div");

                    mobileTabContent.appendChild(contentToAppend);
                }
            });
        }
    } catch (error) {
        console.log(error);
    }
});
// For Product Variant selection
window.addEventListener("load", function() {

  // let allProdVariants = document.querySelectorAll(".prod-custom-info variant-radios fieldset input");  
  // allProdVariants.forEach((ele)=>{
  //    ele.addEventListener("click", ()=>{
  //        let otherVariants = ele.closest("fieldset").nextElementSibling.querySelector("input");
  //        if(otherVariants != null){
  //            if(!otherVariants.checked){
  //                otherVariants.click();
  //            }
             
  //        }   
  //    });
  // });
try {
  let allProdVariants = document.querySelectorAll(".prod-custom-info variant-radios fieldset input");
// let xov;
  allProdVariants.forEach((ele)=>{
     ele.addEventListener("click", ()=>{
         // console.log(ele, "clicked");
         let otherVariants = ele.closest("fieldset").nextElementSibling.querySelectorAll("input");
    setTimeout(() => {
          for (let i = 0; i < otherVariants.length; i++) {
            // console.log(otherVariants[i], i)
             if ((!otherVariants[i].disabled) ) {
                // console.log(otherVariants[i], "enabled");
                otherVariants[i].click();
              break;
                 }
          }
    }, 200);


     });
  });



}
catch(error) {
        console.log(error);
}
});